import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { BaseButton } from '@/scenarios/legacy-player/components/PlayerSkin/parts/BaseButton/BaseButton';
import { BaseButtonColor } from '@/scenarios/legacy-player/components/PlayerSkin/parts/BaseButton/BaseButton.types';

import styles from './styles.module.css';

interface Props {
    skipButtonText?: string;
    renderSkipButtonIcon?: (className?: string) => ReactNode;
    cancelButtonText?: string;
    renderCancelButtonIcon?: (className?: string) => ReactNode;
    className?: string;
    autoSkipTime?: number;
    onCancelClick: () => void;
    onSkipClick: () => void;
    hideCancelButton?: boolean;
    onSkipButtonShow?: (element: HTMLDivElement | null) => void;
}

export const SkipButtonGroup: FC<Props> = ({
    skipButtonText,
    renderSkipButtonIcon,
    cancelButtonText,
    renderCancelButtonIcon,
    className,
    autoSkipTime,
    onSkipClick,
    onCancelClick,
    hideCancelButton = false,
    onSkipButtonShow,
}) => (
    <div className={classnames(styles.root, className)} ref={onSkipButtonShow}>
        {!hideCancelButton && (
            <BaseButton onClick={onCancelClick} className={styles.button}>
                {renderCancelButtonIcon?.(styles.icon)}
                {cancelButtonText || (
                    <FormattedMessage
                        id="features.player.369c97846792fb1b579409e88c881182"
                        defaultMessage="Watch now"
                        description="Текст по умолчанию для группы кнопок для того, чтобы оставить титры и тд в плеере"
                    />
                )}
            </BaseButton>
        )}
        <BaseButton
            onClick={onSkipClick}
            className={styles.button}
            color={BaseButtonColor.orange}
            isAnimated={!!autoSkipTime}
            animationDuration={autoSkipTime}
        >
            {renderSkipButtonIcon?.(styles.icon)}
            {skipButtonText || (
                <FormattedMessage
                    id="features.player.72ef2b9b6965d078e3c7f95487a82d1c"
                    defaultMessage="Skip"
                    description="Текст по умолчанию для группы кнопок для пропуска титров и пр в плеере"
                />
            )}
        </BaseButton>
    </div>
);
